import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[smDecimalOnly]'
})
export class DecimalOnlyDirective {
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/);  // allow max 2 digits after decimal
  private specialKeys: string[] = [
    'Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Delete'
  ];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.specialKeys.includes(event.key)) {
      return;
    }

    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const cursorPosition = input.selectionStart ?? currentValue.length;

    // Handle inserting at cursor position
    const newValue =
      currentValue.slice(0, cursorPosition) +
      event.key +
      currentValue.slice(cursorPosition);

    if (!this.regex.test(newValue)) {
      event.preventDefault();
    }
  }

  // Optional: Clean pasted input
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pastedInput: string = event.clipboardData?.getData('text/plain') ?? '';
    if (!/^\d*\.?\d{0,2}$/.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
